import { IMerchant } from '@interfaces/merchant';
import { DealDetailState } from './slice/dealDetailSlice';
import { DealState } from './slice/dealSlice';
import { MilesConversionState } from './slice/milesConversionSlice';
import { POSState } from './slice/posSlice';
import { PrivilegeDetailState } from './slice/privilegeDetailSlice';
import { PrivilegeState } from './slice/privilegeSlice';
import { RedemptionState } from './slice/redemptionSlice';
import { RedemptionsState } from './slice/redemptionsSlice';
import { TransactionState } from './slice/transactionDetailSlice';
import { TransactionsState } from './slice/transactionsSlice';
import { UserState } from './slice/userSlice';

export enum LoadingState {
	IDLE = 'idle',
	PENDING = 'pending',
	SUCCESSED = 'succeeded',
	FAILED = 'failed',
}
export type LoadingStateType = LoadingState.IDLE | LoadingState.FAILED | LoadingState.PENDING | LoadingState.SUCCESSED;

export enum UserEnum {
	OUTLET = 'OUTLET',
	POS = 'POS',
}

export type UserType = UserEnum.OUTLET | UserEnum.POS;

export interface FetchUserProps {
	userType: UserType;
	id: string;
}
export interface IUser {
	name: string;
	allowRefundAtOutletAndPOS: boolean;
	outletName?: string;
	_id: string;
	merchant: IMerchant;
}

export interface RootState {
	userState: UserState;
	transactionsState: TransactionsState;
	transactionDetailState: TransactionState;
	posState: POSState;
	redemptionState: RedemptionsState;
	redemptionDetailState: RedemptionState;
	dealState: DealState;
	dealDetailState: DealDetailState;
	privilegeState: PrivilegeState;
	milesConversionState: MilesConversionState;
	privilegeDetailState: PrivilegeDetailState;
	_persist: {
		version: number;
		rehydrated: boolean;
	};
}
